import Swal from 'sweetalert2';
import { Subscription } from 'rxjs/Rx';
import { Component, OnInit, OnChanges, ViewChild, ElementRef, OnDestroy, Output, Input, EventEmitter, AfterViewChecked ,HostListener} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Logger } from 'angular2-logger/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { PusherService } from '../../../shared/pusher.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { SocketioService } from '../../socketio.service';
import { SharedService } from '../../../shared/shared.service';
import { DashboardService } from '../../dashboard.service';
import { MatTableDataSource } from '@angular/material';
import { Ng4FilesService, Ng4FilesConfig, Ng4FilesStatus, Ng4FilesSelected } from 'angular4-files-upload';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs/observable/interval';
import { startWith } from 'rxjs/operators';
import { RoomService } from './room.service';
import { UserService } from '../../../admin/user/user.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { ListComponent } from '../list/list.component';
import * as moment from 'moment';
import { environment } from './../../../../environments/environment';


declare var jquery: any;
declare var $: any;
declare var window: any;
declare var MediaRecorder: any;

@Component({
    selector: 'app-room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss'],
    providers: [PusherService, UserService]
})

export class RoomComponent implements OnInit, OnChanges, AfterViewChecked {
    public form: FormGroup;
    public room_id: string;
    public selectedFiles;
    public msg: string = '';
    public url: string = '';
    public type: string = '';
    public openPopup: Function;
    public block_room: any;
    public btn_control: boolean;
    public list_type: string;
    public title: string;
    public role_id: any;
    public user: any;
    public user_id: any;
    public holding_by: any;
    public class_control: any;
    public saidReturn: any;
    public name_aux: any;
    public valores_aux: any;
    public templateVariables: any;
    public namePa = environment.namePA;
    public historyRoom: any;
    public roomsMsg: any;
    public states: any;
    public status_list: any = [];
    public id_status: any;
    public selectedStatusAgent: string;
    public status_agent: string;
    public hours: number = 0;
    public minutes: number = 0;
    public seconds: number = 0;
    public interval: number;  
    public timeLimitColor: string ; 
    public timeLimit: number;
    public timeTotalVideocall:number;
    public enableVideocall:boolean = false;
    public messageVideocall:string;
    public enableRecording:boolean;
    public meetingIdVideocall:string;
    public durationVideocall:number;
    public urlVideocall:string;
    private mediaRecorder: any;
    private audioChunks: any[] = [];
    public isRecording: boolean = true;
    public audioBlob: Blob | null = null;
    public audioURL: string;
    public safeAudioURL: SafeUrl;
    public stream: MediaStream | null = null;
    public chatTextBox:boolean = true;
    public activeTab: string = 'activos'; 
    public activosList : any =[];
    public inactivosList : any = [];
    @ViewChild('audioPlayer') audioPlayer: ElementRef;

    public pivote: string = '';
    public matriz_resueltos = [];
    public matriz_tiempo = [];
    public matriz_transferidos = [];
    public said_prueba = [];
    public tagsResponse: any = [];
    public tagsResult: string = "";
    public tagSelect: string = "";
    public tagsReady: any[] = [];
    public selectedIdTags: string;
    public tagsSelect: any;
    public filter: FormGroup;
    public dataSource = new MatTableDataSource;
    public displayedColumns = [
        " "
    ];

    public dataHistorialRooms: any;
    public dataHistorialRooms2: any;

    public pais_select: any;

    public object_said: Object;
    public matriz_nueva_prueba: any;
    public matriz_aux = [];
    public matriz_global = [];
    public k: any = 0;

    public variable_nueva: any;
    public id_category: any;

    public matriz_final: any;


    public title_toModal: string;
    public body_toModal: string;
    public active_agents: any;
    public info_templates: any;
    public num: number = 1;

    private banderaRoomId: any;
    public banderaMensajes: any;
    public dropdownList2 = [];
    public state_report: any;
    itemsInput: any[] = [];
    public selectedItems = [];
    public dropdownSettings = {};

    public detalle_plantilla: any;
    public variables: any;
    public template_id: any;

    public id_ticket: any;

    public valorHtml: any;

    files: any[] = [];

    @Input() selectedRoomID: any;

    @Input() banderaList: any;

    @Input() plataformaRoom: any;

    public tipologia1: any;
    public tipologia2: any;
    public tipologia3: any;
    public tipologia4: any;
    public tipologia5: any;
    public banderaNivel: any;
    public tags1: any;
    public tags2: any;
    public tags3: any;
    public tags4: any;
    public tags5: any;


    private intervalSub: Subscription;
    private intervalSubBySession: Subscription;
    private subscription: Subscription = new Subscription();
    private sendMessageInProgress: boolean = false;
    public statusRooms: any;

    selectedNodes2: any[] = [];
    selectedNivel1: any;
    selectedNivel2: any;
    selectedNivel3: any;
    selectedNivel4: any;
    selectedNivel5: any;
    selectedStatus: any;
    selectedTagsLevel1: any;
    selectedTagsLevel2: any;
    selectedTagsLevel3: any;
    selectedTagsLevel4: any;
    selectedTagsLevel5: any;

    arraySelectTypology = [];

    statusTicket = [
        { id: 2, name: 'Abierto' },
        { id: 3, name: 'Pendiente' },
        { id: 5, name: 'Cerrada' }
    ];

    tipologiaNivel1 = [];
    tipologiaNivel2 = [];
    tipologiaNivel3 = [];
    tipologiaNivel4 = [];
    tipologiaNivel5 = [];
    tagsLevel1 = [];
    tagsLevel2 = [];
    tagsLevel3 = [];
    tagsLevel4 = [];
    tagsLevel5 = [];

    setPopupAction(fn: any) {
        this.openPopup = fn;
    }

    onEnterFunction(event) {
        this.sendMessage();
    }
    @ViewChild('scrollMsj') private myScrollContainer: ElementRef;
    @ViewChild('closebutton') closebutton;

    message: string = "actualizar";

    @Output() messageEvent = new EventEmitter<string>();

    windowLeft = '0.7vw';
    windowTop = '1.6vh';
    windowWidth ='58.4vw';
    windowHeight = '66vh';

    private isResizing = false;
    private isDragging = false;

    private initialX: number;
    private initialY: number;

    isMinimized = false;
    isMaximized = false;

    showWindow = false;

    onWindowMouseMove(event: MouseEvent) {
        if (this.isDragging) {
            const newX = event.clientX - this.initialX;
            const newY = event.clientY - this.initialY;
            /* this.windowLeft = newX;
            this.windowTop = newY; */
        }
    
        if (this.isResizing) {
            const deltaX = event.clientX - this.initialX;
            const deltaY = event.clientY - this.initialY;
            this.windowWidth += deltaX;
            this.windowHeight += deltaY;
            this.initialX = event.clientX;
            this.initialY = event.clientY;
        }
    }
    
    /*  stopDrag() {
    this.isDragging = false;
    }


    stopResize() {
        this.isResizing = false;
    } */

    minimizeWindow() {
        const videoCall =document.getElementById("videoCall")
        videoCall.style.width = '20.5vw';
        videoCall.style.height = '34vh';

        this.windowLeft = '-24.5vw';
        this.windowTop = '40vh';
        this.windowWidth = '23.5vw';
        this.windowHeight = '40vh';
    
    }
    
    maximizeWindow() {
        const videoCall =document.getElementById("videoCall")
        videoCall.style.width = '57vw';
        videoCall.style.height = '60vh';
        
        this.windowLeft = '0.7vw';
        this.windowTop = '1.6vh';
        this.windowWidth ='58.4vw';
        this.windowHeight = '66vh';
        
    
    }
    
    closeWindow() {
        const roomId = { roomId: this.meetingIdVideocall };

        if (this.subscription) {
            this.subscription.unsubscribe(); 
        }
        clearInterval(this.interval); 

        this.showWindow = false;
        this.showModalVideoCall();

        this.saidService.deactivateRoom(roomId).subscribe(
            response => {
                this.logger.log(response);
            },
            err => {
                this.logger.error(err);
            }
        );

        this.saidService.getSession(this.meetingIdVideocall).subscribe(
            response => {
                if(response.data.length > 0){

                    const sessionData = {
                        "start": response.data[0].start,
                        "end": response.data[0].end
                    };
                    const start = new Date(sessionData.start);
                    const end = new Date(sessionData.end);

                    this.durationVideocall = (end.getTime() - start.getTime()) / 1000;
                }
                
            },
            err => {
                this.logger.error(err);
            }
        );

        this.saidService.getRecordingMeeting(this.meetingIdVideocall).subscribe(
            response => {

                if (response.data.length > 0) {
    
                    this.urlVideocall = response.data[0].file.fileUrl;
                } else {
                    this.urlVideocall = '';
                }

                
            },
            err => {
                this.logger.error(err);
            }
        );
    }
    showFloatingWindow() {
        this.showWindow = true;
    }

    constructor(
        private saidService: RoomService,
        private fb: FormBuilder,
        private _router: Router,
        private ng4FilesService: Ng4FilesService,
        public _socketioService: SocketioService,
        private logger: Logger,
        private _dashboardService: DashboardService,
        private _sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        public toastr: ToastsManager,
        private pusherService: PusherService,
        private spinner: NgxSpinnerService,
        private userService: UserService,
        private ListComponent: ListComponent,
        private sanitizer: DomSanitizer

    ) {

        this.form = this.fb.group({
            nombre: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]]
        });

        this.filter = this.fb.group({
            textoFiltro: [],
            city: []
        });


        this.btn_control = true;

        this.holding_by = null;

        this.block_room = this._sharedService.activateBlockSupervisor().isAdmin;

        let data = {
            auth_token: this._sharedService.getCookie("auth_token")
        };

        this.spinner.show();
        this._sharedService.getCurrent(data).subscribe(
            data => {
                if (data.status) {
                    this.user = data.data;
                    this.user_id = this.user.id;
                    this.role_id = this.user.role_id;
                    var self = this;
                    // subscribe to router event

                } else {
                    // Esta línea fue la que puse 
                    //this.rooms.getRoomMsgs(this.room_id);
                    this.logger.log(data.message); // Que no tengo permisos. 
                }
            },
            error => {
                //this.spinner.hide();
                this.logger.log(error);

            }
        );
        this.form = this.fb.group({
            user_id: [null, []],
            room_id: [null, []],
            date_sent: ['', []],
            content: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(250)]]
        });

        this.list_type = this._sharedService.activateRouteTabArchived();

        this.tipologia1 = true;
        this.tags1 = true;
        this.banderaNivel = '1';
    }

    private testConfig: Ng4FilesConfig = {
        acceptExtensions: ['jpg', 'png', 'gif', 'pdf'],
        maxFilesCount: 5,
        //maxFileSize: 512000,
        maxFileSize: 2512000,
        totalFilesSize: 40120000
    };


    ngAfterViewChecked() {
        if (this._socketioService.rooms[this.room_id] && this._socketioService.rooms[this.room_id].msgs) {
            let cantidadMsj = this._socketioService.rooms[this.room_id].msgs;
            let valorComporar = cantidadMsj.length;
            if (valorComporar != this.banderaMensajes) {
                this.scrollToBottom();
                let cantidadMensajes = this._socketioService.rooms[this.room_id].msgs;
                this.banderaMensajes = cantidadMensajes.length;
            }
        }

        if (this.room_id != this.banderaRoomId) {
            if (this._socketioService.rooms[this.room_id] && this._socketioService.rooms[this.room_id].msgs) {
                this.getTags();
                this.scrollToBottom();
                this.banderaRoomId = this.room_id;
                let cantidadMensajes = this._socketioService.rooms[this.room_id].msgs;
                this.banderaMensajes = cantidadMensajes.length;
            }
        }
    }

    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }

    itemMentioned(tag) {
        return tag.display;
    }

    onFileDropped($event) {
        this.uploadFile($event);
    }

    loadRoom() {
        if (this.selectedRoomID) {
            this.room_id = this.selectedRoomID;

            let vData = {
                auth_token: this._sharedService.getCookie("auth_token"),
                room_id: this.room_id
            }

            this.userService.getInfoRooms(vData).subscribe(
                data => {
                    for (let i in data.data.dataInfo) {
                        this.id_ticket = data.data.dataInfo[i].id_ticket;
                    }
                });

            this._dashboardService.roomId(this.room_id);
            let data = this.getDataParamToStatusControl();
            this.statusControl(data);
            if (this._sharedService.activateRouteTabArchived() === 'archived') {
                this.list_type = this._sharedService.activateRouteTabArchived();
            }
            this.getTagsInRoomAsync();
            this._socketioService.getRoomMsgs(this.room_id);
        }
    }

    ngOnChanges() {
        
        if (this.selectedRoomID) {
            $('#controlTags').appendTo("body");
            $('#controlTags').modal({ backdrop: "static", keyboard: false, show: false });
            this.loadRoom();
        }
    }

    handleSelection(event) {
        this.msg += event.char;
        
    }

    ngOnInit() {
        
        this.getTypology('');
        this.getTagsAsync();
        this.valorHtml = '{{}}';
        this.dropdownSettings = {
            singleSelection: false,
            text: 'Seleccionar etiqueta',
            searchPlaceholderText: 'Buscar',
            selectAllText: 'Seleccionar Todos',
            unSelectAllText: 'Deseleccionar Todos',
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };
        
        if(localStorage.getItem('videocall') == '1' && environment.enableVideocall){
            this.enableVideocall = true;
        }

        this.pais_select = '+57';

        this.banderaRoomId = '';
        
        this.title = "Toma de control";
        this.ng4FilesService.addConfig(this.testConfig);
        this._socketioService.load.subscribe(
            data => {
                if (data) {
                    //this.spinner.show()
                } else {
                    //this.spinner.hide()
                }
            }
        );


        this.intervalSub = interval(30000).pipe(
            startWith(30000)).subscribe(i => {
                if (!this.sendMessageInProgress) {
                    let data = this.getDataParamToStatusControl();
                    this.statusControl(data);
                }
            });

        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            room_id: this.room_id
        };

        this._sharedService.getCategorias(data).subscribe((returndata) => {
            this.matriz_final = returndata.message.categorias;

            for (let i = 0; i < returndata.message.categorias.length; i++) {
                this.matriz_final[i].valores = [];
                this.id_category = returndata.message.categorias[i].id;

                this.variable_nueva = returndata.message.descripciones.filter(description => description.id == this.id_category);

                this.matriz_final[i].valores = this.variable_nueva;
            }
        });

        this.saidService.getIds(data).subscribe((returndata) => {

            this.saidReturn = returndata.message;
            this.tagsSelect = this.saidReturn.tagsSelect;

        });

        let dat = {
            auth_token: this._sharedService.getCookie('auth_token'),
            room_id: this.selectedRoomID
        };

        this._dashboardService.getVariables(dat).subscribe(
            data => {
                for (let i in data.data.data) {
                    this.itemsInput.push({ tag: data.data.data[i].display_name, display: data.data.data[i].valor, position: i, type: 'operator' });
                }
                this.spinner.hide();
            },
            error => {

                this.spinner.hide();
                this.logger.log(error);

            }
        );


        let dataStatus = { 
            auth_token: this._sharedService.getCookie("auth_token")
        };

        this._sharedService.getStatusConetion(dataStatus).subscribe(
            data => {
            let valuei= 0;

            for (let i = 0; i < data.data.length; i++) {
            let vClass = '';

            if (data.data[i].id_status == this.id_status) {
                vClass = 'active';
            }
            this.status_list[i] = 
            {'id': data.data[i].id_status, 'itemName':data.data[i].description, 'avaliable':data.data[i].avaliable, 'clase': vClass};
            valuei = i;  
            }
            this.selectedStatus = this.status_list[0].id;
            
            },
            error => {
                
                this.spinner.hide();
                this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );

        
    }

    getTags() {
        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            room_id: this.room_id
        };

        this.saidService.getIds(data).subscribe((returndata) => {
            let retorno = returndata.message;

            this.tagsSelect = retorno.tagsSelect;
        });
    }

    ngOnDestroy() {
        $("body>#controlRoom").remove();
        $("body>#controlTags").remove();
        $("body>#variablesTemplate").remove();
        $("body>#modalTicket").remove();
        $("body>#videocallExit").remove();
        
        
        if (this.intervalSub) {
            this.intervalSub.unsubscribe();
        }
    }

    public filesSelect(selectedFiles: Ng4FilesSelected): void {
        if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {
            this.selectedFiles = selectedFiles.status;
            return;
            // Hnadle error statuses here
        }
        this.selectedFiles = Array.from(selectedFiles.files).map(file => file.name);
        this._dashboardService.uploadfiles(selectedFiles.files[0]).subscribe(response => {
            // respuesta
        },
            error => {
                this.logger.log(error);
            });
    }

    sendEnter(event) {
        this.sendMessage();
    }

    onKeydown(event) {
        event.preventDefault();
    }

    onPaste(e: any) {
        const items = (e.clipboardData || e.originalEvent.clipboardData).items;
        let fileUpload = null;
        for (const item of items) {
            if (item.type.indexOf('image') === 0) {
                fileUpload = item.getAsFile();

                const fechaActual = moment();
                const formattedDate = fechaActual.format("YYYY-MM-DDTHH:mm:ss.SSS");
                const originalName = fileUpload.name;
                const [nameWithoutExtension, extension] = originalName.split('.'); // Separar nombre de extensión

                // Modificar solo el nombre de la imagen
                const newName = `${nameWithoutExtension}_${formattedDate}.${extension}`;
                fileUpload = new File([fileUpload], newName, { type: fileUpload.type });
            }
        }
        const reader = new FileReader();
        reader.onload = (event: any) => {
            this.spinner.show();
            this._dashboardService.uploadfiles(fileUpload).subscribe(response => {
                this.spinner.hide();

                this._socketioService.getRoomMsgs(this.room_id);
            },
                error => {
                    this.logger.log(error);
                    this.spinner.hide();
                });

        };

        if (fileUpload) {
            reader.readAsDataURL(fileUpload);

        }
    }

    sendMessage1(status: number) {
        this.messageEvent.emit(this.message)
    }





    changeStatus(status: number) {

        if (this.id_ticket) {
            this.statusRooms = status;
            $('#modalTicket').modal('toggle');
            $('#modalTicket').appendTo("body");

        } else {
            this.statusRooms = status;
            this.closeRooms(this.statusRooms);
        }
    }


    closeRooms(status: number) {
        let arraySelect = [];

        if (this.selectedNivel1) {
            arraySelect.push(
                this.selectedNivel1.id
            );
        }

        if (this.selectedNivel2) {
            arraySelect.push(
                this.selectedNivel2.id
            );
        }

        if (this.selectedNivel3) {
            arraySelect.push(
                this.selectedNivel3.id
            );
        }

        if (this.selectedNivel4) {
            arraySelect.push(
                this.selectedNivel4.id
            );
        }

        if (this.selectedNivel5) {
            arraySelect.push(
                this.selectedNivel5.id
            );
        }

        let data = {
            status_id: status,
            selectTypology: arraySelect,
            selectedStatus: this.selectedStatus,
            videocallTime: this.timeTotalVideocall,
            urlVideocall: this.urlVideocall,
            durationVideocallSdk: this.durationVideocall
        };
        console.log("Informacion enviada para el backend timepos y url",data);

        this.spinner.show();
        this._dashboardService.changeRoomStatus(data).subscribe(
            response => {
                if (response.code_status === 200) {
                    if (response.message === 'Ocurrió un error') {
                        this.title_toModal = "Advertencia - Falló la comunicación con la plataforma de BOTs";
                        this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                        $('#controlRoom2').modal('toggle', { backdrop: "false" });
                        $('#controlRoom2').appendTo("body");
                        this.spinner.hide();
                    }
                    else if (response.message === 'room.errorTicket') {
                        
                        this.title_toModal = "Advertencia - " + response.data.description;
                        this.body_toModal = "Ups!. Ha ocurrido un error con Freshdesk.\n\nCampo: " + response.data.field + "\n\nDescripción: " + response.data.message + "\n\nLa etiqueta tiene demasiados caracteres, eliminela o agregue una más pequeña.";
                        $('#controlRoom2').modal('toggle', { backdrop: "false" });
                        $('#controlRoom2').appendTo("body");
                        $('#modalTicket').modal('hide');    
                        
                        this.spinner.hide();
                    }
                    else {
                        
                        this.ListComponent.banderaList = false;
                        this.room_id = '';
                        this.messageEvent.emit(this.message);
                        this.logger.log("Room status sent: ");
                        this.logger.log(response);
                        this.spinner.hide();
                        $("body>#modalTicket").remove();
                    }
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    $('#controlRoom2').modal('toggle', { backdrop: "false" });
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                    this.logger.log(response);
                }
            },
            error => {
                this.logger.log(<any>error);
            }
        );
    }

    activeControlBtn() {
        let user = '';
        if (this.title == 'Toma de control') {
            this.title = "Dejar control";
            user = this.user_id;
        } else {
            this.title = "Toma de control";
            user = null;
        }

        let data = {
            user_id: this._sharedService.activateBlockSupervisor().agent_id,
            room_id: this.room_id,
            supervisor_id: user
        }
        this._dashboardService.takeStatusControl(data).subscribe(
            data => {
                
                this.holding_by = data.data.holding_by;
            });
    }

    private statusControl(data: any) {
        if (null != data) {
            this._dashboardService.getStatusControl(data).subscribe(resp => {
                
                if (resp.data) {
                    this.holding_by = resp.data.holding_by;
                }
                this.title = this.holding_by !== null ? "Dejar control" : "Toma de control";
                
            });
            
            this._socketioService.getRoomMsgs(data.room_id);
        }
    }

    private getDataParamToStatusControl() {
        let data = null;
        if (this.role_id === 3 || this.role_id === 6) {
            data = {
                user_id: this.user_id,
                room_id: parseInt(this.room_id)
            };
        } else if (this._sharedService.activateBlockSupervisor().agent_id !== null) {
            data = {
                user_id: this._sharedService.activateBlockSupervisor().agent_id,
                room_id: parseInt(this.room_id)
            };
        }

        return data;
    }
    // Me trae los agentes disponibles para asignación de chats.
    asignarAgente() {
        
        let data;
        this.spinner.show();
        let user = '';
        if (this._sharedService.activateBlockSupervisor().agent_id) {
            user = this._sharedService.activateBlockSupervisor().agent_id;
        } else {
            user = this.user_id;
        }
        data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            user_id: user,
            room_id: this.room_id,
            supervisor_id: this.btn_control ? this.user_id : null
        }

        this.userService.getAgents(data).subscribe(
            (data) => {
                if (data.data) {
                    this.activosList = data.data.Activos;
                    this.inactivosList = data.data.Inactivos;
                    this.title_toModal = "Agentes";
                    this.body_toModal = "Si hay usuarios";
                    $('#controlRoom').modal('toggle', { backdrop: false });
                    $('#controlRoom').appendTo("body");
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "No hay usuarios disponibles";
                    $('#controlRoom2').modal('toggle', { backdrop: false });
                    $('#controlRoom2').appendTo("body");
                }
                this.spinner.hide();
            },
            (error) => { 
                this.title_toModal = "Advertencia";
                this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                $('#controlRoom2').modal('toggle', { backdrop: false });
                $('#controlRoom2').appendTo("body");
                this.spinner.hide();
            }
        );
    }

    public newAssignment(data) {
        data.room_id = this.room_id;
        // Nuevos Desarrollos:
        let token = {
            auth_token: this._sharedService.getCookie("auth_token")
        };
        data.auth_token = token;
        data.user_id_anterior = this.user_id;
        
        this.userService.getPreviousUser(data).subscribe(
            response => {
                
                if (this._sharedService.activateBlockSupervisor().agent_id) {
                    data.user_id_anterior = response.data;
                } else {
                    data.user_id_anterior = this.user_id;
                }

                let userIdPrevious = data.user_id_anterior

                Swal({
                    title: "Perfecto",
                    text: 'La conversación No. ' + data.room_id + ' será asignada al agente ' + data.firstname + ' ' + data.lastname + ' en máximo dos minutos!',
                    type: 'success',
                    timer: 5000,
                    showConfirmButton: false
                }).then(() => {
                    
                    this.userService.newAssignment(data).subscribe(data => {
                        let dataUpdatePendin = {
                            user: userIdPrevious,
                            role_id: 1,
                            auth_token: this._sharedService.getCookie('auth_token')
                        };

                        this._dashboardService.roomsPending(dataUpdatePendin).subscribe(
                        );
                        this._router.navigateByUrl("/").then(e => {
                            if (e) {
                                
                            } else {
                                
                            }
                        });
                    }, error => {
                        Swal({
                            title: "Ups!",
                            text: 'Ocurrió un error por favor inténtalo de nuevo.',
                            type: 'error',
                            timer: 5000,
                            showConfirmButton: false
                        });
                    });
                }), error => {
                    Swal({
                        title: "Ups!",
                        text: 'Ocurrió un error por favor inténtalo de nuevo.',
                        type: 'error',
                        timer: 5000,
                        showConfirmButton: false
                    });
                }; 
            }, error => {
                console.error("Ups, hubo un error obteniendo el usuario para cambiar!");
            });

    }

    downloadAttachment(path, name) {
        this._dashboardService.downloadFile(path).subscribe(blob => {
            importedSaveAs(blob, name);
        });

    }

    uploadFile(file: FileList) {

        const fileUpload = file.item(0);
        const reader = new FileReader();
        reader.onload = (event: any) => {
            this.spinner.show();
            this._dashboardService.uploadfiles(fileUpload).subscribe(response => {
                this.spinner.hide();
                this._socketioService.getRoomMsgs(this.room_id);
            },
                error => {
                    this.logger.log(error);
                    this.spinner.hide();
                });
        };
        reader.readAsDataURL(fileUpload);

        const fileInput: any = document.getElementById('fileUpload');
        fileInput.value = null;
    }


    sendMessage() {

        this.sendMessageInProgress = true;

        if (this.holding_by === null && this.role_id === 3 || this.holding_by !== null && this.role_id === 1 || this.holding_by !== null && this.role_id === 5 || this.holding_by == null && this.role_id === 6) {
            this.spinner.show();
            //if (this.holding_by === null && this.role_id === 3 || this.holding_by !== null && this.role_id === 1)  {
            let data = {
                auth_token: this._sharedService.getCookie('auth_token'),
                room: this.room_id,
                message: this.msg,
                user_id: this._sharedService.activateBlockSupervisor().agent_id ? this._sharedService.activateBlockSupervisor().agent_id : this.user_id,
                role_id: this.role_id
            };
            //this.logger.log(data);
            this._dashboardService.sendMessage(data).subscribe( // send to the server
                data => {
                    if (data.status) {
                        
                        data.data.sender = {};
                        data.data.sender = this._sharedService.user;
                        this._socketioService.rooms[data.data.room_id].msgs.push(data.data);
                        this.spinner.hide();


                        this.sendMessageInProgress = false;

                        let datasc = this.getDataParamToStatusControl();
                        this.statusControl(datasc);
                        //this.logger.log(this._socketioService.rooms);
                    } else {
                        this.spinner.hide();
                    }

                },
                error => {
                    this.spinner.hide();
                    this.logger.log(error);

                    this.sendMessageInProgress = false;

                }
            );

            // this._socketioService.getRoomMsgs(this.room_id); 
            this.msg = '';
        }

    }

    updateItemClass(id: string, SharedId: number) {
        return {
            'left': id != SharedId.toString(),
            'right': id == SharedId.toString()
        }
    }

    public cancelInterval() {
        if (this.intervalSub) {
            this.intervalSub.unsubscribe();
        }
    }

    public cancelIntervalBySession() {
        if (this.intervalSubBySession) {
            this.intervalSubBySession.unsubscribe();
        }
    }

    public informacionUser() {
        let data;
        //this.spinner.show();

        data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            room_id: this.room_id
        }

        
    }

    exportHistorialExc(): void {
        this.dataHistorialRooms = this._socketioService.dataReport;
        this.saidService.exportAsExcelFile(this.dataHistorialRooms, 'historial_chat');
    }

    enviarPush() {
        this.spinner.show();

        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            room_id: this.room_id
        }

        this.userService.getTemplatesRooms(data).subscribe(
            data => {
                if (data.message == 'errorAgent') {
                    this.spinner.hide();
                    this.toastr.error("El usuario se encuentra con un agente, intentalo más tarde", 'Error');
                    return;
                }

                if (data.message == 'errorBot') {
                    this.spinner.hide();
                    this.toastr.error("El usuario se encuentra interactuando con el bot, intentalo más tarde", 'Error');
                    return;
                }
                if (data.data.length > 0) {
                    //this.active_agents = data.data;
                    this.info_templates = data.data;
                    this.title_toModal = "Plantillas disponibles";
                    this.body_toModal = "";
                    $('#verPlantillas').modal('toggle', { backdrop: false });
                    $('#verPlantillas').appendTo("body");
                    this.spinner.hide();
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "No hay plantillas disponible";
                    $('#verPlantillas').modal('toggle', { backdrop: "false" });
                    $('#verPlantillas').appendTo("body");
                    this.spinner.hide();
                }
            }, () => {
                this.title_toModal = "Advertencia";
                this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                $('#verPlantillas').modal('toggle', { backdrop: "false" });
                $('#verPlantillas').appendTo("body");
                this.spinner.hide();
            });
    }

    verPlantilla(id) {
        this.template_id = id;

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: id
        };
        this.spinner.show();

        this.userService.getTemplateId(data).subscribe(
            data => {
                if (data.status) {
                    this.detalle_plantilla = this.prepararDatos(data.data.detalle);
                    $('#detailTemplate').modal('toggle');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                //this.load = false;
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    prepararDatos(datos) {
        datos = datos.split("\n").join("<br />");
        return datos;
    }

    selectTemplates(id) {
        this.template_id = id;
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: id
        };
        this.spinner.show();

        this.userService.getTemplateId(data).subscribe(
            data => {
                if (data.status) {
                    this.detalle_plantilla = this.prepararDatos(data.data.detalle);
                    if(data.data.variables=='') {
                        this.templateVariables = false;
                    }else
                        {
                            this.templateVariables = true;
                        }
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.spinner.hide();
                this.logger.log(error);
            }
        );

        this.spinner.show();

        this.userService.getTemplateVariables(data).subscribe(
            data => {
                if (data.status) {
                    this.variables = data.data;
                    $('#variablesTemplate').modal('toggle');
                    $('#variablesTemplate').appendTo("body");
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                //this.load = false;
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    volverPlantillas() {
        this.enviarPush();
    }

    sendPush() {
        let valorVariables = [];
        for (let i = 0; i < this.variables.length; i++) {
            valorVariables.push((<HTMLInputElement>document.getElementById(this.variables[i].valor)).value);
        }

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            variables: valorVariables,
            room_id: this.room_id,
            template_id: this.template_id
        };

        this.spinner.show();

        this.userService.sendPush(data).subscribe(
            data => {
                if (data.status && data.data.status != 'error' && data.data.status != false ) {
                    this.toastr.success('Mensaje enviado con éxito', 'Éxito!');
                    this.changeStatus(15);
                    this.spinner.hide();
                } else {
                    this.spinner.hide();
                    this.toastr.error(data.data.msg, 'Error');
                }
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    changeTipologiaNivel1(valor) {
        this.arraySelectTypology = [];
        this.tipologia2 = false;
        this.tipologia3 = false;
        this.tipologia4 = false;
        this.tipologia5 = false;

        this.selectedNivel2 = [];
        this.selectedNivel3 = [];
        this.selectedNivel4 = [];
        this.selectedNivel5 = [];

        if (!valor) {
            this.tipologia1 = true;
        }
        else {
            this.arraySelectTypology['nivel1'] = valor.id;
            this.banderaNivel = '2';
            this.tipologia2 = true;
            this.getTypology(valor.id);
        }

    }

    changeTipologiaNivel2(valor) {
        delete this.arraySelectTypology['nivel2'];
        delete this.arraySelectTypology['nivel3'];
        delete this.arraySelectTypology['nivel4'];
        delete this.arraySelectTypology['nivel5'];

        this.tipologia3 = false;
        this.tipologia4 = false;
        this.tipologia5 = false;

        this.selectedNivel3 = [];
        this.selectedNivel4 = [];
        this.selectedNivel5 = [];

        if (!valor) {
            this.tipologia2 = true;
        }
        else {
            this.arraySelectTypology['nivel2'] = valor.id;

            this.banderaNivel = '3';
            this.tipologia3 = true;
            this.getTypology(valor.id);
        }
    }

    changeTipologiaNivel3(valor) {
        delete this.arraySelectTypology['nivel3'];
        delete this.arraySelectTypology['nivel4'];
        delete this.arraySelectTypology['nivel5'];

        this.tipologia4 = false;
        this.tipologia5 = false;

        this.selectedNivel4 = [];
        this.selectedNivel5 = [];

        if (!valor) {
            this.tipologia3 = true;
        }
        else {
            this.arraySelectTypology['nivel3'] = valor.id;

            this.banderaNivel = '4';
            this.tipologia4 = true;
            this.getTypology(valor.id);
        }
    }

    changeTipologiaNivel4(valor) {
        delete this.arraySelectTypology['nivel4'];
        delete this.arraySelectTypology['nivel5'];

        this.tipologia5 = false;
        this.selectedNivel5 = [];

        if (!valor) {
            this.tipologia4 = true;
        }
        else {

            this.arraySelectTypology['nivel4'] = valor.id;
            this.banderaNivel = '5';
            this.tipologia5 = true;
            this.getTypology(valor.id);
        }
    }

    changeTipologiaNivel5(valor) {
        delete this.arraySelectTypology['nivel5'];
        if (!valor) {
            this.tipologia5 = true;
        }
        else {
            this.arraySelectTypology['nivel5'] = valor.id;
        }
    }

    async getTypology(valor) {
        this.spinner.show();
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'),
            tipologia1: this.tipologia1,
            tipologia2: this.tipologia2,
            tipologia3: this.tipologia3,
            tipologia4: this.tipologia4,
            tipologia5: this.tipologia5,
            id: valor
        };

        this._dashboardService.getTypology(data).subscribe( // send to the server
            data => {
                if (data.status) {
                    if (data.data) {
                        if (this.banderaNivel == '1') {
                            this.tipologiaNivel1 = data.data;
                        }

                        if (this.banderaNivel == '2') {
                            this.tipologiaNivel2 = data.data;
                        }

                        if (this.banderaNivel == '3') {
                            this.tipologiaNivel3 = data.data;
                        }

                        if (this.banderaNivel == '4') {
                            this.tipologiaNivel4 = data.data;
                        }

                        if (this.banderaNivel == '5') {
                            this.tipologiaNivel5 = data.data;
                        }

                        if (this.banderaNivel == '2' && data.data.length == 0) {
                            this.tipologia2 = false;
                        }

                        if (this.banderaNivel == '3' && data.data.length == 0) {
                            this.tipologia3 = false;
                        }

                        if (this.banderaNivel == '4' && data.data.length == 0) {
                            this.tipologia4 = false;
                        }

                        if (this.banderaNivel == '5' && data.data.length == 0) {
                            this.tipologia5 = false;
                        }

                        this.spinner.hide();
                    }
                }
            },
            error => {
                this.spinner.hide();
                this.logger.log(error);

            }
        );
    }

    aceptarTipologias() {
        if (!this.selectedStatus) {
            this.toastr.warning('Debe seleccionar un estado para el ticket', 'Atención');
            return;
        }

        if (this.tipologia1) {
            let rta = this.arraySelectTypology.hasOwnProperty('nivel1');

            if (rta == false) {
                this.toastr.warning('Debe seleccionar tipología nivel 1', 'Atención');
                return;
            }
        }

        if (this.tipologia2) {
            let rta = this.arraySelectTypology.hasOwnProperty('nivel2');

            if (rta == false) {
                this.toastr.warning('Debe seleccionar tipología nivel 2', 'Atención');
                return;
            }
        }

        if (this.tipologia3) {
            let rta = this.arraySelectTypology.hasOwnProperty('nivel3');

            if (rta == false) {
                this.toastr.warning('Debe seleccionar tipología nivel 3', 'Atención');
                return;
            }
        }

        if (this.tipologia4) {
            let rta = this.arraySelectTypology.hasOwnProperty('nivel4');

            if (rta == false) {
                this.toastr.warning('Debe seleccionar tipología nivel 4', 'Atención');
                return;
            }
        }

        if (this.tipologia5) {
            let rta = this.arraySelectTypology.hasOwnProperty('nivel5');

            if (rta == false) {
                this.toastr.warning('Debe seleccionar tipología nivel 5', 'Atención');
                return;
            }
        }

        this.closebutton.nativeElement.click();

        this.closeRooms(this.statusRooms);
    }


    verHistorial() {
        let data = {
            auth_token: this._sharedService.getCookie('auth_token')
        };

        this.spinner.show();
        this._dashboardService.getHistoryRooms({ data }).subscribe(
            response => {
                if (response.code_status === 200) {
                    this.historyRoom = response.data;
                    this.spinner.hide();
                    $('#modalHistorial').modal('toggle', { backdrop: false });
                    $('#modalHistorial').appendTo("body");
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    $('#controlRoom2').modal('toggle', { backdrop: "false" });
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                }
            },
            error => {
                this.logger.log(<any>error);
            }
        );

    }

    viewChat(id) {
        if (id) {
            this.spinner.show();

            let data = {
                auth_token: this._sharedService.getCookie('auth_token'),
                room_id: id,
            };

            this.userService.getRoomMsgs(data).subscribe(
                data => {
                    if (data.status) {
                        if (data.data) {
                            if (!this.roomsMsg)
                                this.roomsMsg = {};

                            if (!this.roomsMsg.msgs) {
                                this.roomsMsg.msgs = [];
                            }

                            if (this.roomsMsg.msgs.length === 0) {
                                this.dataHistorialRooms2 = data.data.dataReport;
                                this.roomsMsg.msgs = data.data.data;
                            } else {
                                this.roomsMsg.msgs = [];
                                this.roomsMsg.msgs = data.data.data;
                                this.dataHistorialRooms2 = data.data.dataReport;
                            }
                        }

                    } else {
                        //this.load = false;
                    }

                    this.spinner.hide();

                    this.title_toModal = "Conversación No. " + id;
                    this.body_toModal = "Si hay información";
                    $('#historialRooms').modal('toggle', { backdrop: false });
                    $('#historialRooms').appendTo("body");

                },
                error => {
                    console.error("Error to view Chat");

                }
            );
        }
    }

    exportHistorialExc2(): void {
        this.saidService.exportAsExcelFile(this.dataHistorialRooms2, 'historial_chat');
    }

    async getTagsAsync() {
        try {
            const data = await this._dashboardService.getTagsLevel();
            let info = JSON.parse(data);
            this.tagsResponse = [...info];
            this.dataSource.data = this.tagsResponse.map((item, index) => ({
                nombre: item.nombre,
                value: item.id_tags || `Value ${index + 1}`
            }));
        } catch (error) {
            console.error(error);
        }
    }

    async getTagsInRoomAsync() {
        try {
            const data = await this._dashboardService.getTagsInRoom();

            if (Array.isArray(data)) {
                this.tagsReady = [...data];
                this.tagsSelect = this.tagsReady.map((item) => ({
                    nombre: item.nombre,
                    id: item.id
                }));
            } else {
                console.error("La respuesta de la API no es un array", data);
            }
        } catch (error) {
            console.error(error);
        }
    }


    onRowClicked(row: any) {
        this.tagsResult = row.value;
        this.tagSelect = row.nombre;
    }


    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    showTags() {
        if ($('#controlTags').hasClass('show')) {
            $('#controlTags').modal('hide');
                this.cleanTags();
        }else
        {
            if ($('#controlTags').length > 1) {
                $('#controlTags').remove();
    
            }else if ($('#controlTags').length == 0) {
                $('#controlTags').appendTo("body");
                $('#controlTags').modal({ backdrop: "static", keyboard: false, show: false });
                
            }
            $('#controlTags').modal('show', { backdrop: "false" });
        }

    }

    closeTagsModal() {
        $('#controlTags').modal('hide');
        this.cleanTags();
    }

    disposeModal() {
        $('#controlTags').modal('dispose');
    }
    
    cleanTags() {
            this.tagSelect = "";
            this.tagsResult = "";
    }

    aceptarTags() {
        this.spinner.show();

        this._dashboardService.addTags(this.tagsResult, this.room_id).subscribe(
            response => {
                if (response.code_status === 200) {
                    if (response.message == 'tagsExists') {
                        this.spinner.hide();
                        this.toastr.error("Etiquetas ya están agregadas", 'Error');
                        this.cleanTags();
                        return;
                    } else if (response.message == 'This tag association does not exist') {
                        this.spinner.hide();
                        this.toastr.error("La combinacion de etiquetas no existe", 'Error');
                        this.cleanTags();
                    } else {
                        this.logger.log("Etiqueta agregada");
                        this.logger.log(response);
                        this.closebutton.nativeElement.click();
                        this.spinner.hide();
                        this.getTagsInRoomAsync();
                        this.cleanTags();
                    }
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    this.spinner.hide();
                    this.logger.log(response);
                }
            },
            error => {
                this.logger.log(<any>error);
            }
        );
    }

    addNewTags() {
        this.spinner.show();


        this._dashboardService.addTags(this.tagsResult, this.room_id).subscribe(
            response => {
                if (response.code_status === 200) {

                    if (response.message == 'tagsExists') {
                        this.spinner.hide();
                        this.toastr.error("Etiquetas ya están agregadas", 'Error');
                        return;
                    } else {
                        this.logger.log("Etiqueta agregada");
                        this.logger.log(response);
                        this.spinner.hide();
                        this.getTagsInRoomAsync();
                        this.cleanTags();
                    }
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    $('#controlRoom2').modal('toggle', { backdrop: "false" });
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                    this.logger.log(response);
                }
            },
            error => {
                this.logger.log(<any>error);
            }
        );

    }


    deleteTags(id) {
        this.spinner.show();
        this._dashboardService.delTags({ tags: id }).subscribe(
            response => {
                if (response.code_status === 200) {
                    this.logger.log("Etiqueta eliminada");
                    this.logger.log(response);
                    this.spinner.hide();
                    this.getTagsInRoomAsync();
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    $('#controlRoom2').modal('toggle', { backdrop: "false" });
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                    this.logger.log(response);
                }
            },
            error => {
                this.logger.log(<any>error);
            }
        );
    }

    changeStatusAgent(id,detalle) {
        this._sharedService.updateData({ id: id, detalle: detalle });   
    }

    closeModal (nameModal:string){
        $(`body>#${nameModal}`).remove();
    }

    getItemNameById(id: string): string {
        const status = this.status_list.find(item => item.id == id);
        return status ? status.itemName : '';
    }

    async videoCall() {
        await this.infoPanel();
        
        this.changeStatusAgent(0,"En Videollamada");
        this.timerVideocall();
        const roomData = { customRoomId: this.namePa + this.room_id,};
        this.showFloatingWindow();
        
        const roomSubscription = this.saidService.createRoom(roomData).subscribe(
            (response) => {
                
                this.meetingIdVideocall = response.roomId;
                const name = this.user.firstname + ' ' + this.user.lastname;
                const url = `https://videocall.smartdataautomation.com/?meetingId=${this.meetingIdVideocall}&?paName=${this.namePa}&?recordingEnabled=${this.enableRecording}`;
                /* this.VideoCallService.createVideoCall(name, this.meetingIdVideocall,this.enableRecording); */
                const data={meeting_id:this.meetingIdVideocall, name_user:name, recording:this.enableRecording}
                this._sharedService.runVideocall(data);

                if(this.enableRecording){
                    this.msg= this.messageVideocall + '<br>' + 'Para ingresar a la llamada con su asesor por favor ingrese al siguiente link:<br> ' + url;
                }else{
                    this.msg ='Para ingresar a la llamada con su asesor por favor ingrese al siguiente link:<br> ' + url;
                }
                this.sendMessage();
            
            },
            (error) => {
                console.error('Error al crear la sala', error);
            }
        );
        this.subscription.add(roomSubscription);
    }

    showModalVideoCall(){
        $('#videocallExit').modal('toggle', { backdrop: "false" });
        $('#videocallExit').appendTo("body");
    }

    timerVideocall(): void {
        
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;

        const timeString = localStorage.getItem('videocallDuration'); 
        const [hours, minutes, seconds] = timeString.split(':').map(Number); 
        const timeTotalSetting = hours * 3600 + minutes * 60 + seconds ;
        const timeLimit30Percent  = timeTotalSetting - (timeTotalSetting * 0.30);
        const timeLimit10Percent  = timeTotalSetting - (timeTotalSetting * 0.10);


        this.interval = window.setInterval(() => {
            this.seconds++;

            if (this.seconds === 60) {
                this.seconds = 0;
                this.minutes++;
            }

            if (this.minutes === 60) {
                this.minutes = 0;
                this.hours++;
            }

            const totalSeconds = this.hours * 3600 + this.minutes * 60 + this.seconds;
            this.timeTotalVideocall = totalSeconds;
            
            if (totalSeconds >= timeLimit10Percent) {
                this.timeLimitColor = 'red';
            }else if (totalSeconds >= timeLimit30Percent){
                this.timeLimitColor = 'orange';
            }else {
                this.timeLimitColor = 'black';
            }
            
        }, 1000);
    }

    async infoPanel() {
        let data = { auth_token: this._sharedService.getCookie("auth_token") };
        const response = await this._sharedService.getInfoPanel(data).toPromise();
    
        if (response.message.videocallRecording == '1') {
            this.messageVideocall = response.message.messageRecording;
            this.enableRecording = true;
        } else {
            this.messageVideocall = '';
            this.enableRecording = false;
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    bloquearRecarga(event: any) {
        
        if (this.showWindow) {
        event.returnValue = '';
        }
    }

    @HostListener('window:unload', ['$event'])
    onUnload(event: any) {
        if(this.showWindow){
            sessionStorage.setItem("isReloadingVideocall", JSON.stringify(this.showWindow));
        }
    }

    startRecording() {
        this.chatTextBox = false;

        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            
            let options: any = {};
            if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
                options.mimeType = 'audio/webm;codecs=opus';
            } else {
                console.error("El formato audio/webm;codecs=opus no es soportado en este navegador.");
                return;
            }
            
            this.mediaRecorder = new MediaRecorder(stream, options);
            this.audioChunks = [];
            this.stream = stream; 
    
            this.mediaRecorder.ondataavailable = event => {
                if (event.data.size > 0) {
                    this.audioChunks.push(event.data);
                }
            };
    
            this.mediaRecorder.onstop = () => {
                
                this.audioBlob = new Blob(this.audioChunks, { type: options.mimeType });
                this.audioURL = URL.createObjectURL(this.audioBlob);
                this.safeAudioURL = this.sanitizer.bypassSecurityTrustUrl(this.audioURL);
                
                console.log("Audio grabado correctamente:", this.audioBlob);
                this.stream.getTracks().forEach(track => track.stop());
            };
    
            this.mediaRecorder.start();
            this.isRecording = false;
            
        }).catch(error => {
            console.error("Error al acceder al micrófono:", error);
        });
    }
    
        
    stopRecording() {
        if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
            this.mediaRecorder.stop();
            this.isRecording = true;
            setTimeout(() => {
                if (this.audioPlayer && this.audioPlayer.nativeElement) {
                    this.audioPlayer.nativeElement.load();
                }
                
            }, 10);

            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
            }
        }
    }
        
    uploadAudio() {
        if (!this.audioBlob) {
            console.error("No hay audio disponible para enviar.");
            return;
        }
    
        const audioFile = new File([this.audioBlob], 'recording.mp3', { type: 'audio/mpeg' });
    
        this.spinner.show();
        this._dashboardService.uploadfiles(audioFile).subscribe(
            response => {
                this._socketioService.getRoomMsgs(this.room_id);
                this.spinner.hide();
                this.clearAudio(); 
            },
            error => {
                console.error('Error subiendo el audio:', error);
                this.spinner.hide();
            }
        );
    }
    
    sendAudio() {
        if (this.audioBlob) {
            this.uploadAudio();
            this.chatTextBox = true;
        } else {
            console.error("No hay audio disponible para enviar.");
        }
    }
    

    discardAudio() {
        this.clearAudio();
        this.chatTextBox = true;
    }

    clearAudio() {
        this.audioBlob = null;
        this.audioURL = null;
        this.safeAudioURL = null;
    }

    changeTab(tab: string) {
        this.activeTab = tab;
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/room/room.component.ts